module.exports = __webpack_public_path__ + "static/media/bvlgari-man-in-black-big.1fd9ef93.png";